export { AppwriteExceptionTranslator } from "./translator";
export { LocalTranslationProvider } from "./providers/LocalTranslationProvider";
export type { ITranslator } from "./interfaces/ITranslator";
export type { ITranslationProvider } from "./interfaces/ITranslationProvider";
export type { IAppwriteException } from "./interfaces/IAppwriteException";

// Create a default instance with the local provider for convenience
import { AppwriteExceptionTranslator } from "./translator";
import { LocalTranslationProvider } from "./providers/LocalTranslationProvider";

export const createDefaultTranslator = () => {
	return new AppwriteExceptionTranslator(new LocalTranslationProvider());
};
